import { render, staticRenderFns } from "./Orbs.vue?vue&type=template&id=5e5c8666&"
import script from "./Orbs.vue?vue&type=script&lang=ts&"
export * from "./Orbs.vue?vue&type=script&lang=ts&"
import style0 from "./Orbs.vue?vue&type=style&index=0&id=5e5c8666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports